import { RouteRecordRaw } from 'vue-router';
import { MatrixFillPocPage } from '@/pages/sandbox';

export const routeName = 'MatrixFillPoc';

export const route: RouteRecordRaw = {
  path: 'sandbox/matrix-fill/:id?',
  name: routeName,
  component: MatrixFillPocPage,
  meta: {
    requiresAuth: true,
    breadcrumb: 'POC Preenchimento de Matriz',
  },
};
